import * as types from "@/store/constants/types";
import { sendEvent } from "@/utils/analytics";
import router from "@/router/router";
export default {
  [types.INITIAL_TIME_STAMP](state: any, payLoad: any) {
    state.initTime = payLoad;
  },
  [types.UPDATE_DOUBLE_COIN_BUBBLE_STATUS](state: any, payLoad: any) {
    if (state.showDoubleCoinBubble !== payLoad) {
      state.showDoubleCoinBubble = payLoad;
    }
  },
  [types.UPDATE_SUPER_PAY_BUBBLE_STATUS](state: any, payLoad: any) {
    if (state.showSuperPayBubble !== payLoad) {
      state.showSuperPayBubble = payLoad;
    }
  },
  [types.UPDATE_SUPER_PAY_BUBBLE_SHOW_DATE](state: any, payLoad: any) {
    if (state.showSuperPayBubbleDate !== payLoad) {
      state.showSuperPayBubbleDate = payLoad;
    }
  },
  [types.UPDATE_SUPER_PAY_BUBBLE_CLICK_STATUS](state: any, payLoad: any) {
    if (state.superPayBubbleClick !== payLoad) {
      state.superPayBubbleClick = payLoad;

      if (payLoad) {
        sendEvent("uia_superapp_recommend_click", "tab4_bubble");
      }
    }
  },
  [types.UPDAE_LIMITED_COIN_BUBBLE_STATUS](state: any, payLoad: any) {
    state.isShowLimtedCoinBubble = payLoad;
  },
  [types.UPDATE_LIMITED_COIN_SHOW](state: any, payLoad: any) {
    state.isShowLimtedCoin = payLoad;
  },
  [types.UPDATE_LIMITED_COIN_INTERVAL_TIME](state: any, payLoad: any) {
    state.limtedIntervalTime = payLoad;
  },
  [types.UPDATE_SUPER_PAY_RECOMMEND_CLICK_DATE](state: any, payLoad: any) {
    state.superPayRecommendClickDate = payLoad;
  }
};
